import { EditorState, convertToRaw, ContentState, convertFromRaw, convertFromHTML } from 'draft-js'
import draftToMarkdown from 'draftjs-to-markdown'
import draftToHtml from 'draftjs-to-html'
import { mdToDraftjs, draftjsToMd } from 'draftjs-md-converter'
import htmlToDraft from 'html-to-draftjs'

export const convertToHTMl = data => {
    const rawData = mdToDraftjs(data);
    const contentState = convertFromRaw(rawData);
    const newEditorState = EditorState.createWithContent(contentState);
    const content = newEditorState.getCurrentContent();
   //  console.log('content', convertToRaw(content))
    const html = draftToHtml(convertToRaw(content));

    return html
}